// extracted by mini-css-extract-plugin
export default {"footer":"ujPtgq","footerV2":"JLJYbP","footerCroutonButton":"AAmtYF"};